function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 *
 * @private
 * @param {any} a
 */
function isObject(a) {
  if (_typeof(a) !== 'object' || a instanceof Array) {
    return false;
  } else {
    return true;
  }
}

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);
  }

  _createClass(Config, [{
    key: "filterOutNonSupportedKeys",
    value: function filterOutNonSupportedKeys(userProvidedConfig, validKeys) {
      var obj = Object.create({});

      if (isObject(userProvidedConfig)) {
        Object.keys(userProvidedConfig).forEach(function (key) {
          if (validKeys.indexOf(key) >= 0) {
            obj[key] = userProvidedConfig[key];
          } else {
            console.warn('Warning - unsupported key provided to configuration: ', key);
          }
        });
        return obj;
      } else {
        return Object.create({});
      }
    }
  }]);

  return Config;
}();

export default Config;